import { Component, OnInit, Inject, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { PlanService } from '../plan.service';
import { Plan } from '../plan';
import { Observable, empty } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Contact } from '../../contacts/contact';
import { faEdit, faUserPlus, faTrashAlt, faClone, faClipboard} from '@fortawesome/free-solid-svg-icons';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { Customer } from '../../customers/customers';
import { ContactsService } from '../../contacts/contacts.service';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { io } from 'socket.io-client';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { dropdownObj } from 'src/app/raterform/raterform/raterform.component';


@Component({
  selector: 'app-edit-plans-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './edit-plan-dialog.html',
  styleUrls: ['./plans.component.css']
})
export class EditPlanDialogComponent implements OnInit {

  // tslint:disable-next-line: max-line-length
  constructor(public dialogRef: MatDialogRef<EditPlanDialogComponent>, @Inject (MAT_DIALOG_DATA) public data: Plan, private log: LoggingService, private fb: FormBuilder, public planService: PlanService, private messager: MessagerComponent, public contactService: ContactsService, public ges: GlobalEmailService, private cd: ChangeDetectorRef ) {}

  planForm = new FormGroup({
    plan_name : new FormControl(this.data.plan_name || ''),
    newplannm : new FormControl(this.data.newplannm || ''),
    plan_family : new FormControl(this.data.plan_family || ''),
    plan_notes : new FormControl(this.data.plan_notes || ''),
    hvac1_ceil_ht : new FormControl(this.data.hvac1_ceil_ht || 0),
    hvac_1_area : new FormControl(this.data.hvac_1_area || 0),
    hvac2_ceil_ht : new FormControl(this.data.hvac2_ceil_ht || 0),
    hvac_2_area : new FormControl(this.data.hvac_2_area || 0),
    hvac3_ceil_ht : new FormControl(this.data.hvac3_ceil_ht || 0),
    hvac_3_area : new FormControl(this.data.hvac_3_area || 0),
    hvac4_ceil_ht : new FormControl(this.data.hvac4_ceil_ht || 0),
    hvac_4_area : new FormControl(this.data.hvac_4_area || 0),
    addvol : new FormControl(this.data.addvol || 0),
    bedrooms : new FormControl(this.data.bedrooms || 0),
    bathrooms : new FormControl(this.data.bathrooms || 0),
    stories : new FormControl(this.data.stories || 0),
    windowarea : new FormControl(this.data.windowarea || 0),
    customer : new FormControl(this.data.customer || 0),
    drivelink : new FormControl(this.data.drivelink || ''),
    base_plan : new FormControl(this.data.base_plan || ''),
    base_plan_reviewed : new FormControl(this.data.base_plan_reviewed || false),
    envelopearea : new FormControl(this.data.envelopearea || 0),
    unittype : new FormControl(this.data.unittype || ''),
  });

  @ViewChild('custname', { read: false, static: false}) custNameInputRef: ElementRef;
  plan_id = this.data.plan_id;
  mode = this.data.mode;

  customername = '';
  drivelink = this.planForm.get('drivelink').value;

  unittypes: dropdownObj[] = [
    { value: 'Deatached', viewValue: 'Detached' },
    { value: 'Interior', viewValue: 'Interior' },
    { value: 'End Unit', viewValue: 'End Unit' },
    { value: 'Apartment', viewValue: 'Apartment' }
  ];

  isLoading = false;
  filteredCustomers: Customer[] = [];
  customer$: Observable<Customer[]>;

  displayFunction(customer: Customer) {
    if (customer) { return customer.customer_name; }
}

  onSelectCustomer(customer: Customer): void {
    this.data.customer = customer.customer_id;
    this.planForm.get('customer').setValue(customer.customer_id);
    this.data.customer = customer.customer_id;
    this.data.customer_name = customer.customer_name;
    this.customername = customer.customer_name;
    //this.planForm.get('customer_name').setValue(customer.customer_name);
    this.custNameInputRef.nativeElement.value = customer.customer_name;
  }

  updateDriveLink(): void {
    //this.cd.detectChanges();
    this.drivelink = this.planForm.get('drivelink').value;
  }


  ngOnInit() {

    this.customer$ = this.planForm.get('customer').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getCustomersDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );

  }

  save() {

    let changedProperties = [];
      Object.keys(this.planForm.controls).forEach((name) => {
            const currentControl = this.planForm.controls[name];

            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.planForm.controls[name].value);
            }
      });

    this.planService.saveEditedPlan(this.data.plan_id, this.planForm.value).subscribe(
      (res) => {

        this.log.info(this.data.loggedIn + ' saved the following edits to plan ' + this.planForm.value.plan_name.trim() + ' {' + changedProperties.toString() + '}' );
        this.dialogRef.close();


        if(res.Error){

          let errMessage = res.Message;


          this.messager.openSnackBar('Error saving plan, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.planForm.value,'Plans', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for plans page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the plan page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            })

          this.log.error(this.data.loggedIn + ' encountered an error editing a plan: Submitted data: ' + '{' + this.planForm.value.toString() + '} ' + res.Message );
        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error creating a plan: Submitted data: ' + '{' + this.planForm.value.toString() + '} ' + err.toString() );
      }
    );
  }

  add() {
    this.planService.addPlan(this.planForm.value).subscribe(
      res => {
        this.log.info(this.data.loggedIn + ' created the plan ' + this.planForm.value.plan_name.trim() );
        this.dialogRef.close();

        if(res.Error){

          let errMessage = res.Message;


          this.messager.openSnackBar('Error saving plan, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.planForm.value,'Plans', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for plans page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the plan page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            });

          this.log.error(this.data.loggedIn + ' encountered an error creating a plan: Submitted data: ' + '{' + this.planForm.value.toString() + '} ' + res.Message.toString() );
        }else {

            this.log.info(this.data.loggedIn + ' added a plan ' + this.planForm.get('plan_name').value.trim()  );

        }
      },
      err => {
        this.log.error(this.data.loggedIn + ' encountered an error creating a plan: Submitted data: ' + '{' + this.planForm.value.toString() + '} ' + err.toString() );
      }
    );
  }

}

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent implements OnInit {

  @ViewChild('table', { static: false}) table: APIDefinition;

  public configuration: Config;
  public columns: Columns[];
  public toggledRows = new Set<number>();
  editData;

  faedit = faEdit;
  fatrash = faTrashAlt;
  fagoogle = faGoogle;
  faclone = faClone;
  faclipboard = faClipboard;

  modal = false;
  selected;

  plan$: Observable<Plan[]>;
  currentplan: Observable<Plan>;

  pagename: string;
  user;
  usernamee;
  private socket: any;
  // tslint:disable-next-line: max-line-length
  parseFloat = parseFloat;
  displayedColumns: string[] = ['plan_family', 'plan_name', 'customer_name', 'plan_notes', 'bedrooms', 'bathrooms', 'totalarea', 'totalvolume', 'heightarea1', 'heightarea2'];

  constructor(public planService: PlanService, public dialog: MatDialog, public auth: AuthService, public log: LoggingService, public messager: MessagerComponent ) {

    //this.socket = io('http://localhost:5000');
    this.socket = io('https://raterhelperv3.herokuapp.com');

   }

   form = new FormGroup({
    bedfilter: new FormControl(''),
    areafilter: new FormControl(''),
    volumefilter: new FormControl(''),
    notefilter: new FormControl(''),
    namefilter: new FormControl(''),
  });


  ngOnInit(): void {

    this.planService.init();
    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.plan$ = this.planService.getInitial().pipe(
      tap(() => {
        this.configuration.isLoading = this.planService.isLoading;
      })
    );

    this.columns = [
      { key: '', title: '', searchEnabled: false, width: '40px'},
      { key: 'plan_family', title: 'Plan family' },
      { key: 'plan_name', title: 'Plan_name' },
      { key: 'customer_name', title: 'Customer_name' },
      { key: 'plan_notes', title: 'Plan_notes' },
      { key: 'bedrooms', title: 'Bedrooms' },
      { key: 'bathrooms', title: 'Bathrooms' },
      { key: 'totalarea', title: 'Total Area' },
      { key: 'totalvolume', title: 'Total Volume'},
      { key: 'heightarea1', title: 'Quick View' }
    ];

    this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

    this.socket.on('newPlan', data => {
      this.planService.addOneFrontend(data.newOne);
    });

  }// NG-ONINIT

  onFilterChange(event: Event): void {
    const bedValue = this.form.get('bedfilter')?.value;
    const areaValue = this.form.get('areafilter')?.value;
    const volumeValue = this.form.get('volumefilter')?.value;
    const noteValue = this.form.get('notefilter')?.value;
    const nameValue = this.form.get('namefilter')?.value;
    this.planService.getFilteredPlans(bedValue, areaValue, volumeValue, noteValue, nameValue)
  }

  reset(): void {
    this.planService.resetFilter();
    this.form.get('bedfilter').setValue('');
    this.form.get('areafilter').setValue('');
    this.form.get('volumefilter').setValue('');
    this.form.get('notefilter').setValue('');
    this.form.get('namefilter').setValue('');


    this.toggledRows.forEach(e => {
      this.table.apiEvent({
        type: API.toggleRowIndex,
        value: e
      });
      this.toggledRows.delete(e);
    });

  }

  gotobaseplan(row): string{
    return 'https://' + row.base_plan;
  }

  copyPlan(row): void {

    //get current timestamp
    const timestamp = new Date().getTime().toString().substring(8);
    //get plan name
    const newObj = JSON.parse(JSON.stringify(row));
    newObj.drivelink = '';

    if (/^.*_Copy_\d{4}$/.test(row.plan_name)) {
      newObj.plan_name = row.plan_name.replace(/_Copy_\d{4}$/, `_Copy_${timestamp}`).trim();
    } else {
        newObj.plan_name = row.plan_name.trim() + '_Copy_' + timestamp;
    }

      this.planService.addPlan(newObj).subscribe(
        res => {
          this.log.info(this.usernamee + ' duplicated the plan ' + row.plan_name + ' to ' + newObj.plan_name);
          if(res.Error){
          }else {
              this.log.info(this.usernamee + ' added a plan ' + row.plan_name.trim());
          }
        },
        err => {
          this.log.error(this.usernamee + ' encountered an error creating a plan: Submitted data: ' + '{' + row.toString() + '} ' + err.toString() );
        }
      );
    //console.log(row);
  }

  openDialog(mydata): void {

    this.planService.getOnePlan(mydata.plan_id).subscribe( (tdata: any) => {
      const dialogRef = this.dialog.open(EditPlanDialogComponent, {
        height: '80vw',
        width: '70vw',
        data: {
          plan_id: tdata.Plan.plan_id,
          have_plans: tdata.Plan.have_plans,
          have_manj: tdata.Plan.have_manj,
          have_mand: tdata.Plan.have_mand,
          have_mans: tdata.Plan.have_mans,
          base_plan_reviewed: tdata.Plan.base_plan_reviewed,
          required_hers_index: tdata.Plan.required_hers_index,
          inactiveplan: tdata.Plan.inactiveplan,
          hvac1_ceil_ht: tdata.Plan.hvac1_ceil_ht,
          hvac2_ceil_ht: tdata.Plan.hvac2_ceil_ht,
          hvac3_ceil_ht: tdata.Plan.hvac3_ceil_ht,
          hvac4_ceil_ht: tdata.Plan.hvac4_ceil_ht,
          reviewed_by: tdata.Plan.reviewed_by,
          review_date: tdata.Plan.review_date,
          windowarea: tdata.Plan.windowarea,
          plan_name: tdata.Plan.plan_name,
          customer: tdata.Plan.customer,
          customer_name: mydata.customer_name,
          plan_notes: tdata.Plan.plan_notes,
          bedrooms: tdata.Plan.bedrooms,
          bathrooms: tdata.Plan.bathrooms,
          stories: tdata.Plan.stories,
          hvac_1_area: tdata.Plan.hvac_1_area,
          hvac_2_area: tdata.Plan.hvac_2_area,
          hvac_3_area: tdata.Plan.hvac_3_area,
          hvac_4_area: tdata.Plan.hvac_4_area,
          ratercompid: tdata.Plan.ratercompid,
          windsch: tdata.Plan.windsch,
          newplannm: tdata.Plan.newplannm,
          addvol: tdata.Plan.addvol,
          plan_family: tdata.Plan.plan_family,
          drivelink: tdata.Plan.drivelink,
          base_plan: tdata.Plan.base_plan,
          envelopearea: tdata.Plan.envelopearea,
          unittype: tdata.Plan.unittype,
          mode: 1,
          loggedIn : this.usernamee
        },
        panelClass: 'edit-dialog-container'
      });

      dialogRef.afterClosed().subscribe(result => {
        this.editData = result;
      });

    });

  } //open dialog

  newPlan(): void {
    const dialogRef = this.dialog.open(EditPlanDialogComponent, {
      height: '80vw',
      width: '70vw',
      data: {
        mode: 2,
        loggedIn : this.usernamee
      },
      panelClass: 'edit-dialog-container'
    });
  }

  gotoGDrive(row): string {


    if(row.drivelink){
      if(row.drivelink.length < 35){
        return  'https://drive.google.com/drive/u/0/folders/' + row.drivelink;
      }else {
        return row.drivelink;
      }
    }else {
      return '';
    }


  }

  addDriveFolder(row, index): void {

    let planID = row.plan_id;
    var createObject = {
      plan_id : row.plan_id,
      plan_name: row.plan_name
    }

/*
    var modalOptions = {
      closeButtonText: 'Close',
      headerText:row.plan_name,
      bodyText: 'This plan does not have a drive folder, please create one.'
    };
*/
    //$scope.gridOptions.data[index].folderid = 'www.google.com';


      this.planService.createDriveFolder(createObject)
      .subscribe(
        res=> {
        if(res.Error){
          this.messager.openSnackBar('Drive folder was creation failed ' + res.Message, '', 'errorAlert');
        }else {
          //let index = index;
          this.messager.openSnackBar('Drive folder was created successfully.', '', 'successAlert');
          this.planService.updateIndexOf(index, res.File.data.id);
        }},err => {
          this.messager.openSnackBar('Creation failed: ' + err, '', 'errorAlert');
        }
      );

  }


  deleteDialog(plan): void {
    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to delete ' + plan.plan_name + '? This will also un-assign it from any locations currently using it.',
        delete_api_url: '/rhAPI/plans/deleteOne/',
        delete_id: plan.plan_id,
        delete_header_text: 'Deleting [' + plan.plan_name + ']',
        extra_data: { deleted_by: this.usernamee }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.planService.deleteOnePlan(plan.plan_id);
        this.log.info(this.usernamee + ' deleted the plan: ' + plan.plan_name + ' id: ' + plan.plan_id);
      }
    })




  }

  topFunction(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }






}
